import { renderCompat as t, getDefaultSlot as n } from "../util/vue-compat/index-vue2.js";
import { createInstantSearchComponent as e } from "../util/createInstantSearchComponent.js";
export default e({
  name: "AisInstantSearchSsr",
  inject: {
    $_ais_ssrInstantSearchInstance: {
      default: function _default() {
        throw new Error("`createServerRootMixin` is required when using SSR.");
      }
    }
  },
  data: function data() {
    return {
      instantSearchInstance: this.$_ais_ssrInstantSearchInstance
    };
  },
  render: t(function (t) {
    var e;
    return t("div", {
      class: (e = {}, e[this.suit()] = !0, e[this.suit("", "ssr")] = !0, e)
    }, n(this));
  })
});